import { Swiper, Navigation } from 'swiper';

Swiper.use([Navigation]);


const sliderSections = document.querySelectorAll(".s-re-agency-detail-branches");

sliderSections.forEach(slideSection => {
  const slider = slideSection.querySelector(".s-re-agency-detail-branches__slider");
  const buttonPrev = slideSection.querySelector(".swiper-button-prev");
  const buttonNext = slideSection.querySelector(".swiper-button-next");

  const swiperSettings = {
      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      },
      slidesPerView: "auto",
      draggable: true,
      spaceBetween: 16,
      updateOnWindowResize: true,
      initialSlide: 0,
  };

  new Swiper(slider, swiperSettings);
});

